import React, {Component} from 'react'
import PropTypes from "prop-types";
import RequestUpdateFileComponent from "./RequestUpdateFileComponent";
import {authenticationService} from "../../services/AuthenticationService";
import SvGraphics from "../../assets/SvGraphics";

class RequestUpdateFiles extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            fileForms: this.props.fileForms,
            otherForms: this.props.otherForms,
            addedFilesList:this.props.addedFilesList,
            selectedCategory:"",
            selectedFile: {},
        }
    }

    componentDidMount() {
        let {selectedCategory} = this.state
        if (!selectedCategory)
            this.saveSelectedCategory('20')
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    getPatientAge(birthday) {
        if (birthday !== null) {
            let todayDate = new Date().toISOString()
            let todayExactDate = (todayDate.split('T'))[0].split('-')
            let currentYear = todayExactDate[0]
            let currentMonth = todayExactDate[1]
            let birthDate = birthday ? birthday.toISOString() : ""
            let exactDate = (birthDate.split('T'))[0].split('-')
            let yearDiff = currentYear - exactDate[0]
            let monthDiff = currentMonth - exactDate[1]
            if (monthDiff < 0) {
                return (yearDiff - 1) + "." + (12 + monthDiff)
            } else {
                return yearDiff + "." + (monthDiff)
            }
        }
        return ""
    }

    saveSelectedFile=(event)=>{
        this.setState({selectedFile:event})
    }

    saveSelectedCategory=(event)=>{
        this.props.onValueChange("selectFileCategory", event)
        this.setState({selectedCategory:event})
    }

    render(){
        let {t} = this.props

        let {fileForms,entry,selectedCategory,selectedFile,otherForms} = this.state

        let currentUser = authenticationService.currentUserValue;
        let language = localStorage.getItem('language')
        let fromLanguage
        if (language === "he") {
            fromLanguage= "Form_desc_he"
        }else{
            fromLanguage= "Form_desc"

        }

        let transporterComp
        let filesToUpload = fileForms.map(item => {

            if(entry.transporter ==="Yes" && item.withPrescription==="T"){
                transporterComp= <RequestUpdateFileComponent Form_type_ID={item.Form_type_ID}
                                                             Form_desc_he={item[fromLanguage]}
                                                             entry={entry}/>
            }
            
            let isNewRequest=entry.choose_programm ==="new"||entry.choose_programm ==="newPrescription"
            let isRenew2Request=entry.choose_programm ==="renew2"||entry.choose_programm ==="renew2Prescription"
            let isRenewRequest=entry.choose_programm ==="renew"||entry.choose_programm ==="renewPrescription"
             console.log(entry.choose_programm,"entry.choose_programm" )
             console.log(item.withPrescription,"item.withPrescription" )

                return (
                    (
                        ((isNewRequest||isRenew2Request)&& item.withPrescription === "P"
                            && (entry.Psychiatric_diagnosis ==="Yes" ||entry.Nuclear_family_psychosis ==="Yes"||entry.Drug_abuse ==="Yes")) ||
                        // A = license requests only (new, renew, renew2), not the *Prescription variants
                        ((entry.choose_programm === "new" || entry.choose_programm === "renew" || entry.choose_programm === "renew2") && item.withPrescription === "A") ||
                        (isNewRequest && (item.withPrescription === "N"|| item.withPrescription === "M")) ||
                        (isRenewRequest && item.withPrescription === "R") ||
                        (isRenew2Request && (item.withPrescription === "Y" || item.withPrescription === "N")) ||
                        (entry.choose_programm ==="change" && item.withPrescription==="C"))
                    && <RequestUpdateFileComponent Form_type_ID={item.Form_type_ID}
                                                   Form_desc_he={item[fromLanguage]}
                                                   entry={entry}/>
                )
            }
        )

        if(transporterComp){
            filesToUpload=filesToUpload.concat(transporterComp)
        }

        let addedFilesList=this.props.addedFilesList
        let forms= otherForms.map(item=> {
                return <option value={item.Form_type_ID}>{item[fromLanguage]}</option>
            }
        )
        let addedFiles=[]


        addedFiles= addedFilesList.map((item,index)=>{
            return (
                <div className={'patientsFormRow-uploadFiles'}>
                    <label className={'uploaded-files-label-category'}>{item.Form_type.Form_desc_he}</label>
                    <a href={item.Form_url} target="_blank" className={'uploaded-files-label-view'}>View uploaded file</a>
                    <SvGraphics className={'uploaded-files-label-button'}
                                onClick={() => this.props.deleteUploadedFile(index)} svgname={'delete-icon'}/>
                </div>
            )
        })

        return (


            <div className={'patientsFormBoxes'}>
                {filesToUpload}
                <div className={'blankSpace'}/>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <select className={'selectBox'} id="selectFileCategory" name="selectFileCategory" value={selectedCategory?selectedCategory:'20'}
                                onChange={(event)=>this.saveSelectedCategory(event.target.value)}>
                            <option/>
                            {forms}
                        </select>
                    </div>
                    <input className={'chooseFileStyle'} type="file" name="image_uploads" id="file-input" onChange={(event)=>this.saveSelectedFile(event.target)}/>

                    {!this.props.isUploadingFiles&&<div className={'buttonStyle'}>
                        <div
                            onClick={() => this.props.addFileObj(addedFilesList.length, selectedCategory, selectedFile)}>{t('patient_self_boarding.addFile')}</div>
                    </div>}

                    { this.props.isUploadingFiles&& <div className="loader-uploadfiles"/>}


                </div>


                {addedFiles}

                <div className={'blankSpace'}/>
            </div>

        )
    }
}

RequestUpdateFiles.propTypes = {
    onValueChange: PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default RequestUpdateFiles;
